import { useRef, useState } from "react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";

export const HoverPreview = ({ children, preview, testId }) => {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const endTouch = () => { clearTimeout(timer.current); setOpen(false); };

  return (
    <HoverCard open={open} onOpenChange={setOpen} openDelay={150} closeDelay={50}>
      <HoverCardTrigger asChild>
        <div
          className="shrink-0 select-none"
          onTouchStart={() => { timer.current = setTimeout(() => setOpen(true), 450); }}
          onTouchEnd={endTouch}
          onTouchMove={endTouch}
          onContextMenu={(e) => e.preventDefault()}
          data-testid={`${testId}-trigger`}
        >
          {children}
        </div>
      </HoverCardTrigger>
      <HoverCardContent side="right" align="start" sideOffset={12} collisionPadding={12}
        className="pointer-events-none w-[480px] max-w-[90vw] overflow-hidden rounded-xl border-border bg-black p-0 shadow-2xl"
        data-testid={`${testId}-content`}>
        <div className="aspect-video w-full">{preview}</div>
      </HoverCardContent>
    </HoverCard>
  );
};
